import { apiClient } from "../config";
async function userprofilenotifications(notifiData: any) {
  const res = await apiClient.put(`/admin/profile/notification`, notifiData);
  return res.data;
}

export default userprofilenotifications;
